import { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Grid } from '@material-ui/core';
import { useStyles } from './styles';
import { SettingsTabs } from 'components/SettingsTabs';

const Settings: FC = observer(() => {
  const classes = useStyles();

  useEffect(() => {
    document.title = 'EasyIdentity: Settings:  Email Templates';
  }, []);

  return (
    <Container maxWidth='xl' className={classes.container}>
      <Grid className={classes.infoContainer} container alignItems='stretch' justify='space-between' spacing={3}>
        <SettingsTabs />
      </Grid>
    </Container>
  );
});

export default Settings;
